import { render, staticRenderFns } from "./KategoriCampaignPopup.vue?vue&type=template&id=4f2338e4&scoped=true"
import script from "./KategoriCampaignPopup.vue?vue&type=script&lang=js"
export * from "./KategoriCampaignPopup.vue?vue&type=script&lang=js"
import style0 from "./KategoriCampaignPopup.vue?vue&type=style&index=0&id=4f2338e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2338e4",
  null
  
)

export default component.exports